/* eslint-disable */
import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "./Base";
import QueryableInterface from "@/interfaces/QueryableInterface";

const endpoint = API_ENDPOINT + "/admin";

@Component
export default class UsersMixin extends Base {
  getUsers(params: QueryableInterface, tag: string) {
    const queryString = this.paramsToQueryString(params);
    const url = `${endpoint}/users.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }
}
